import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function Games() {
  const navigate = useNavigate();

  const games = [
    {
      title: "Look at That (LAT)",
      link: "https://drive.google.com/file/d/1hewt9KtCAy45eLnB6k76HO7pzkpZb2JV/view?usp=sharing",
    },
    {
      title: "Desensitisation to Harness",
      link: "https://drive.google.com/file/d/1_f0QrCYt5sc7FXbY49yZesyq2c64f_j0/view?usp=sharing",
    },
    {
      title: "Engaging in a Calming Activity",
      link: "https://drive.google.com/file/d/1RwHTT1JQI2vC1vtQf6hrkPipI2sq0USE/view?usp=sharing",
    },
    {
      title: "Teaching a Relaxed Down Stay",
      link: "https://drive.google.com/file/d/11NPvuIuX07xVeVUI4cVk4Hz6WiEDpCNh/view?usp=sharing",
    },
    {
      title: "The Treat Trail",
      link: "https://drive.google.com/file/d/1iQdySFynqWgnoJiOiU-G_B1ymKDOYwTi/view?usp=sharing",
    },
    {
      title: "Sit and Stay Near",
      link: "https://drive.google.com/file/d/146Mrp1MZH6QpA8mGMJ9_nY9DMgLwA5YX/view?usp=sharing",
    },
    {
      title: "The Calm Cue",
      link: "https://drive.google.com/file/d/1A2jsJ9u5f5mMbQND6Z_IsSSfRWDDFAah/view?usp=sharing",
    },
    {
      title: "Middle",
      link: "https://drive.google.com/file/d/1dvxSneeWRcMSogQJpRnFtN4JZUUNXVC0/view?usp=drive_link",
    },
    {
      title: "Hide and Seek",
      comingSoon: true,
    },
    {
      title: "Find It",
      comingSoon: true,
    },
  ];

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 p-8">
        <button
          onClick={() => navigate("/home")}
          className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm"
        >
          ← Back to Dashboard
        </button>

        <h1 className="text-4xl font-bold text-gray-800 mb-2">Games & Activities</h1>
        <p className="text-lg text-gray-600 mb-8">
          Practical games and activities that reinforce confidence, calm, and connection.
        </p>

        <div className="grid sm:grid-cols-2 gap-4">
          {games.map(({ title, link, comingSoon }) => (
            comingSoon ? (
              <div
                key={title}
                className="p-5 bg-white border border-gray-200 rounded-xl text-center text-gray-500 text-sm border-dashed"
              >
                <p className="text-blue-700 font-semibold text-lg mb-1">{title}</p>
                Coming soon
              </div>
            ) : (
              <a
                key={title}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="block p-5 bg-white border border-gray-200 rounded-xl text-blue-600 hover:border-blue-400 hover:shadow transition text-center font-medium"
              >
                {title}
              </a>
            )
          ))}
        </div>
      </div>
    </>
  );
}

export default Games;
